export default "__VITE_ASSET__CneII9Jv__"